/**
 * Display Options Component
 *
 * Displays options for where to show the shipping bar.
 * Single Responsibility: Render display options section
 */
import { Paper, Stack, Title, Text, Switch, Divider } from '@mantine/core';
import { CustomPlacementInfo } from './CustomPlacementInfo';

export const DisplayOptions = ({ settings, onSettingsChange }) => {
  return (
    <Paper shadow="sm" p="xl" radius="md" withBorder>
      <Stack gap="lg">
        <div>
          <Title order={3} mb="xs">Display Options</Title>
          <Text size="sm" c="dimmed">
            Choose where to show the shipping bar
          </Text>
        </div>

        <CustomPlacementInfo />

        <Divider />

        <Switch
          label="Show on Cart Page"
          checked={settings.show_on_cart}
          onChange={(event) => onSettingsChange({ ...settings, show_on_cart: event.currentTarget.checked })}
        />

        <Switch
          label="Show on Checkout Page"
          checked={settings.show_on_checkout}
          onChange={(event) => onSettingsChange({ ...settings, show_on_checkout: event.currentTarget.checked })}
        />

        <Switch
          label="Show in Mini Cart"
          checked={settings.show_on_mini_cart}
          onChange={(event) => onSettingsChange({ ...settings, show_on_mini_cart: event.currentTarget.checked })}
        />
      </Stack>
    </Paper>
  );
};
